export const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    padding: "20px",
    borderRadius: "8px",
    width: "450px",
    maxHeight: "90vh",
    overflow: "auto",
    boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
    textAlign: "center"
  }
};
